import { render, staticRenderFns } from "./accounts-setup.vue?vue&type=template&id=3a0361df"
import script from "./accounts-setup.vue?vue&type=script&lang=js"
export * from "./accounts-setup.vue?vue&type=script&lang=js"
import style0 from "./accounts-setup.vue?vue&type=style&index=0&id=3a0361df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports